export default (title, isRequired) => {
    return `${title}${isRequired ? ' *' : ''}`;
};
